import clipFromDom from '../utils/clipDom';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import ReplaceText from './replaceText';
import PropTypes from 'prop-types';

import styles from './index.css';
import { getLink } from '../utils';

const Text = ({ needFold = true, text, tag, line = 4, forwardUser, foldBtnText = '全文' }, ref) => {
    const txtRef = useRef();
    const addonRef = useRef();
    const [subTextInfo, setSubTextInfo] = useState({
        text: '',
        line: '',
        overflow: false,
    });
    const link = getLink(text);

    useEffect(
        () => {
            if (needFold && !!text) {
                const res = clipFromDom({
                    content: text,
                    line,
                    ellips: '...',
                    wrapRef: txtRef.current,
                    addonRef: addonRef.current,
                });

                setSubTextInfo(res);
            }
        },
        [text],
    );
    useImperativeHandle(ref, () => ({
        text: needFold ? subTextInfo?.text : text,
    }));

    return (
        <div ref={txtRef} className={styles.text_wrap}>
            {!!text && (
                <>
                    <ReplaceText
                        text={needFold ? subTextInfo?.text : text}
                        tag={tag}
                        forwardUser={forwardUser}
                        link={link}
                    />
                    <span ref={addonRef} className={styles.btn1}>
                        {foldBtnText}
                    </span>
                    {needFold &&
                        !!foldBtnText && (
                            <span
                                className={styles.btn}
                                style={{ display: subTextInfo.line > line && !link ? '' : 'none' }}>
                                {foldBtnText}
                            </span>
                        )}
                </>
            )}
        </div>
    );
};

Text.propTypes = {
    /**
     * 是否需要折叠
     */
    needFold: PropTypes.bool,
    /**
     * 需要匹配的文本
     */
    text: PropTypes.string.isRequired,
    /**
     * 文本匹配替换的标签
     */
    tag: PropTypes.array.isRequired,
    /**
     * 文本展示的行数
     */
    line: PropTypes.number,
    /**
     * 转发的原帖子用户信息
     */
    forwardUser: PropTypes.object,
    /**
     * 展开按钮的文案
     */
    foldBtnText: PropTypes.string,
};

export default forwardRef(Text);
